// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2VKma","title":"InfoRow_title__2iedz"};